// extracted by mini-css-extract-plugin
export var calculatedBadge = "_x4-8";
export var container = "_x4-0";
export var radioDot = "_x4-5";
export var radioDotSelected = "_x4-6";
export var row = "_x4-1";
export var rowFirst = "_x4-2";
export var rowLast = "_x4-3";
export var rowSelected = "_x4-4";
export var strikethrough = "_x4-7";